import { z } from "zod";
import { instantSchema } from "./primitives.js";
import { auditValuesSchema } from "./audit.js";

export const auditViewRowSchema = z.strictObject({
  id: z.string(),
  at: instantSchema,
  actor: z.strictObject({ key: z.string(), name: z.string() }),
  action: z.string(),
  action_label: z.string(),
  action_type: z.string(),
  subject: z
    .strictObject({
      kind: z.string(),
      id: z.string(),
      name: z.string(),
      href: z.string().nullable(),
      state: z.enum(["normal", "restricted", "deleted"]),
    })
    .nullable(),
  reason: z.string().nullable(),
  before: auditValuesSchema.nullable(),
  after: auditValuesSchema.nullable(),
  redacted: z.boolean(),
});
export type AuditViewRow = z.infer<typeof auditViewRowSchema>;

export const auditListResponseSchema = z.strictObject({
  items: z.array(auditViewRowSchema),
  next_cursor: z.string().nullable(),
  total: z.number().int().nonnegative(),
  facets: z.strictObject({
    actors: z.array(z.strictObject({ key: z.string(), name: z.string() })),
    action_types: z.array(z.strictObject({ key: z.string(), label: z.string() })),
    subject_kinds: z.array(z.strictObject({ key: z.string(), label: z.string() })),
  }),
});
export type AuditListResponse = z.infer<typeof auditListResponseSchema>;

export const AUDIT_ACTION_TYPE_LABELS: Record<string, string> = {
  access: "Users and access",
  profiles: "Profiles and plans",
  collection: "Sources and items",
  transcription: "Processing",
  evidence: "Evidence and corrections",
  operations: "Operations and settings",
  platform: "System",
};
